<template>
    <div class="app-container">
        <div
            v-if="title"
            class="title"
        >
            {{ title }}
        </div>
        <div id="pdf-container"></div>
    </div>
</template>

<style>
    #pdf-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .title {
        text-align: center;
        font-size: 20px;
        line-height: initial !important;
        font-weight: bold;
        padding-top: 20px;
    }
</style>

<script>
    export default {
        data() {
            return {
                title: window.title,
                pdfUrl: 'pdf/files/' + window.linkId + '.pdf',
            }
        },
        methods: {
            convertPdfToHtml: function () {
                const self = this
                pdfjsLib.getDocument(this.pdfUrl).promise.then(function (pdf) {
                    self.drawPage(pdf, pdf.numPages, 1)
                })
            },
            drawPage: function (pdf, numPages, pageNumber) {
                const self = this
                const container = document.getElementById('pdf-container')
                pdf.getPage(pageNumber).then(function (page) {
                    const canvas = document.createElement('canvas')
                    const context = canvas.getContext('2d')
                    const viewport = page.getViewport({ scale: 1 })
                    const desiredWidth = container.offsetWidth > 800 ? 800 : container.offsetWidth
                    const scaleFactor = desiredWidth / viewport.width
                    const scaledViewport = page.getViewport({ scale: scaleFactor })
                    canvas.width = scaledViewport.width
                    canvas.height = scaledViewport.height
                    page.render({
                        canvasContext: context,
                        viewport: scaledViewport
                    })
                    container.appendChild(canvas)
                    pageNumber += 1
                    if (pageNumber <= numPages) {
                        self.drawPage(pdf, numPages, pageNumber)
                    }
                })
            }
        },
        mounted() {
            setTimeout(() => {
                this.convertPdfToHtml()
            })
        }
    }
</script>